import merge from 'deepmerge';
import equal from './fast-deep-equal';

const copy = (target) => {
  const starting = Array.isArray(target) ? [] : {};
  return merge(starting, target);
};

/**
 * Sets nested properties in an object
 * @param {Object} obj
 * @param {String} path Nested path as a string
 * @param {Any} value
 * @return {Object} updated object
 * @see https://stackoverflow.com/a/13719796 - Slightly modified
 */
const set = (obj, path, value) => {
  if (!path) {
    return obj;
  }
  let ref = obj;

  path.split('.').forEach((_key, index, arr) => {
    let key = _key;
    if (!Number.isNaN(Number(key))) {
      key = Number(key);
    }

    ref[key] = (index === arr.length - 1) ? value : ref[key] || {};
    ref = ref[key];
  });

  return obj;
};

/**
 *  Gets nested properties in an object without getting errors.
 * @param {Object} obj
 * @param {String} path Period seperated path
 * @param {Any} defaultValue default value to return if undefined (default undefined)
 */
const get = (obj, path, defaultValue = undefined) => {
  const splitPath = path.split('.');
  let value = { ...obj };

  splitPath.forEach((_key, i) => {
    let key = _key;
    if (Number(key)) {
      key = Number(key);
    }
    value = value[key] || (splitPath.length !== i + 1) && {} || undefined; // eslint-disable-line
  });

  return value || defaultValue;
};

export default {
  set, get, copy, equal,
};

export {
  set,
  get,
  copy,
  equal,
  copy as clone, // Alias
};



// WEBPACK FOOTER //
// ./src/helpers/deep.js